import React from "react";
import { Select as AntSelect } from "antd";

const baseInput = {
  width: "100%",
  height: 32,
  padding: "0 10px",
  borderRadius: 6,
  border: "1px solid var(--color-border-subtle)",
  background: "var(--color-bg-surface)",
  color: "var(--color-text-primary)",
  fontSize: 14,
  outline: "none",
  fontFamily: "inherit",
};

export function Label({ children, htmlFor, required }) {
  return (
    <label htmlFor={htmlFor} style={{ display: "block", fontSize: 12, fontWeight: 500, color: "var(--color-text-secondary)", marginBottom: 5 }}>
      {children}
      {required && <span aria-hidden="true" style={{ color: "var(--crm-danger, #DC2626)", marginLeft: 4 }}>*</span>}
    </label>
  );
}

export function Input(props) {
  return <input {...props} style={{ ...baseInput, ...(props.style || {}) }} />;
}

export function Textarea(props) {
  return (
    <textarea
      {...props}
      style={{
        ...baseInput,
        height: "auto",
        minHeight: 80,
        padding: "10px 12px",
        resize: "vertical",
        lineHeight: "20px",
        ...(props.style || {}),
      }}
    />
  );
}

// Drop-in replacement for native <select>. Accepts the same prop shape
// (children of <option>, onChange={e => e.target.value}) but renders an
// antd Select for visual parity with other CRM dropdowns.
export function Select({ children, value, onChange, style, disabled, ...rest }) {
  const options = React.Children.toArray(children)
    .filter((c) => React.isValidElement(c) && c.type === "option")
    .map((c) => ({ value: c.props.value, label: c.props.children, disabled: c.props.disabled }));
  return (
    <AntSelect
      value={value}
      onChange={(v) => onChange && onChange({ target: { value: v } })}
      options={options}
      disabled={disabled}
      style={{ width: "100%", height: 32, ...(style || {}) }}
      {...rest}
    />
  );
}

export function FieldRow({ label, htmlFor, children, hint, required }) {
  return (
    <div style={{ marginBottom: 14 }}>
      {label && <Label htmlFor={htmlFor} required={required}>{label}</Label>}
      {children}
      {hint && <div style={{ fontSize: 12, color: "var(--color-text-secondary)", marginTop: 4 }}>{hint}</div>}
    </div>
  );
}
